<template><div><h1>VUX V2.9.0 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] 支持 事件 on-after-show on-after-hide #2465</li>
</ul>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[fix] 修复 weui-loading 样式</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] 修复 inputAttrs 无默认值导致的报错 #2618</li>
<li>[fix] 修复输入框获取焦点后又失去焦点 #2610</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 支持使用 order-map 自定义列顺序 #2300</li>
<li>[fix] 修复遮罩导致页面滚动 #2593</li>
<li>[feature] 事件 on-confirm 添加当前值 #2632</li>
<li>[fix] 在 nextTick 后触发 on-confirm 事件 #2632</li>
<li>[feature] 支持格式 YYYY-MM-DD A 选择上下午 #2627 @jack87918</li>
</ul>
<h2><a href="/zh-CN/components/inline-x-switch.html">InlineXSwitch</a></h2>
<ul><li>[feature] 新组件 #2624</li>
</ul>
<h2><a href="/zh-CN/components/loading.html">Loading</a></h2>
<ul><li>[fix] 添加变量 loading-z-index 避免与 toast-z-index 冲突 #2484</li>
<li>[enhance] 支持使用空字符隐藏提示文字 #2566</li>
</ul>
<h2><a href="/zh-CN/components/msg.html">Msg</a></h2>
<ul><li>[change] prop:buttons 数组作为 slot:buttons 默认内容</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[enhance] 开发模式下 picker 数据非字符串时显示提示 #2568</li>
</ul>
<h2><a href="/zh-CN/components/popover.html">Popover</a></h2>
<ul><li>[fix] 修复在 fixed 容器里定位不正确 #2590</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] 支持属性 disabled #2594</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[feature] 支持 should-rerender-on-show 实现每次打开重新渲染 #2598</li>
<li>[feature] 支持自动滚动到顶部 #2598</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 添加事件 on-clear #2251</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[fix] 修复新版本 vue 导致的 select 值问题 #2633 #2587</li>
<li>[enhance] 标题使用 v-html #2615</li>
</ul>
<h2><a href="/zh-CN/components/sticky.html">Sticky</a></h2>
<ul><li>[feature] 添加属性 disabled #2601</li>
<li>[enhance] scroll-box 不存在时在开发模式下进行提示</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[feature] 支持使用 bar-position 定义边框位置</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 添加属性 disabled 支持禁用 #2641</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] warn 类型支持 plain 样式 #2478</li>
</ul>
<h2><a href="/zh-CN/components/x-circle.html">XCircle</a></h2>
<ul><li>[feature] 支持渐变色 #2616 @spencer1994</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] 支持样式变量 dialog-gap-width #2640</li>
<li>[enhance] 支持样式变量 dialog-width and dialog-max-width #2577</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复在空值时 valid 为 true 的问题 #2415</li>
<li>[fix] 修复 disabled 样式在 iOS 下过浅的问题 #2458</li>
<li>[change] 仅在获得焦点时显示清除按钮 #2567</li>
<li>[feature] 支持事件 on-click-clear-icon #2603</li>
<li>[enhance] 获得焦点时滚动到可视区域(Android) #2604</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.0-270.vue?3b18ee81